













import { Component, Vue } from "vue-property-decorator";
import FullRouteCityRecuclerList from "../../../components/tabs/route_info/full-route-city-recucler-list.vue";
import ButtonBack from "@/components/buttons/button-back.vue";

import { routeInfo } from "@/config/host.config";
import { IRouteCity } from "@/@types/routeInfo/route-info";
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

@Component({
  components: { FullRouteCityRecuclerList, ButtonBack },
})
export default class RecuclerCityList extends Vue {
  cityList: Array<IRouteCity> = [];

  async getcityList(): Promise<Array<IRouteCity>> {
    const url: string = routeInfo.citys;
    const config: AxiosRequestConfig = {
      params: {
        deleted: true,
      },
    };
    return new Promise<Array<IRouteCity>>((res, rej) => {
      this.$axios
        .get(url, config)
        .then((citys: AxiosResponse) => {
          if (citys.status === 200) {
            res(citys.data);
          }
        })
        .catch((error: AxiosError) => {
          rej(error);
        });
    });
  }

  createDeletedCitys(): void {
    this.getcityList()
      .then((citys: Array<IRouteCity>) => {
        this.cityList = citys;
      })
      .catch((e: AxiosError) => {
        console.log(e);
      });
  }

  deleteCity(id: string): void {
    const i = this.cityList.findIndex((el) => el._id === id);
    if (i < 0) {
      this.createDeletedCitys();
      return;
    }
    this.cityList.splice(i, 1);
    this.$emit("update");
  }

  mounted(): void {
    this.createDeletedCitys();
  }
}
